





































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator';
import {RoleUserAssignationListInput} from '@/modules/authorization/api';
import Pagination from '@/modules/core/model/pagination';
import RoleUserAssignation from '@/modules/authorization/model/RoleUserAssignation';
import {State} from 'vuex-class';
import {VDataTableOptions} from '@/types';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Lista de usuario asignados a un rol
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class AssignedRoleUserList extends Vue {
    /**
     * Ruta de acceso al rol del cual se mostrará la lista de usuarios asignados
     */
    @Prop({type: String, required: true})
    public role: string

    @Prop({type: Boolean, default: false})
    public disabled: boolean

    @State(state => state.authorization.roleUserAssignationList)
    public items: Pagination<RoleUserAssignation>

    public headers = [
        { text: 'Id', value: 'user.id'},
        { text: 'Email', value: 'user.email'},
        { text: 'Nombre', value: 'user.name'},
        { text: 'Acciones', value: 'action', sortable: false },
    ]

    public paginationInput: RoleUserAssignationListInput = {
        page: 1,
        recordsPerPage: 50,
        orderBy: {
            field: 'id',
            direction: 'DESC',
        },
        filters: {
            search: '',
            allUsers: true,
        },
    }

    public select: RoleUserAssignation[] = []
    public updatedAssignationList: RoleUserAssignation[] = []
    public loading = false

    @Watch('role')
    public async onRoleChange (role: string) {
        await this.loadList(role)
    }

    @Watch('select')
    public onSelectChange () {
        this.$emit('change', this.items.items
            .filter(item => {
                return item.hasRole !== (this.select.findIndex(s => s.userId === item.userId) !== -1)
            })
            .map(item => Object.assign(new RoleUserAssignation(), {
                hasRole: !item.hasRole,
                user: item.user,
            })),
        )
    }

    @Watch('disabled')
    public async onDisabledChange (disabled: boolean) {
        if (disabled) {
            return
        }

        await this.loadList(this.role)
    }

    public searchDebounced = _.debounce(function (this: AssignedRoleUserList, search: string) {
        this.paginationInput.filters!.search = search
        this.loadList(this.role)
    }, 500)

    /**
     * Actualizar página
     *
     * Método invocado cuando la tabla lanza el evento "update:options" indicando que el usuario
     * ha modificado las opciones de filtrado de la tabla (página, campo por el cual ordenar,
     * etc..)
     * Solicita al servidor los registros basados en los nuevos filtros y página.
     *
     * @param options
     */
    public async updateTable (options: VDataTableOptions) {
        const orderFields: KeyValuePair = {
            'user.id': 'id',
            'user.email': 'email',
            'user.name': 'name',
        }

        Object.assign(this.paginationInput, {
            page: options.page,
            recordsPerPage: options.itemsPerPage,
            orderBy: {
                field: orderFields[options.sortBy[0]] || 'id',
                direction: (options.sortDesc[0] || false) ? 'desc' : 'asc',
            },
        })

        await this.loadList(this.role)
    }

    /**
     * Carga lista de asignaciones
     *
     * Solicita a la aplicación la carga de una nueva lista de asignaciones de roles a usuario
     *
     * @param role
     */
    public async loadList (role: string) {
        if (this.disabled) {
            return
        }

        this.$emit('loading', this.loading = true)
        await this.$store.dispatch('authorization/loadRoleUserAssignationList', {
            role, input:
            this.paginationInput,
        })

        this.select = this.items.items.filter(i => i.hasRole)
        this.$emit('loading', this.loading = false)
    }

    public reload () {
        this.loadList(this.role)
    }

    public errorCaptured () {
        this.loading = false
    }
}
